/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { SNACKBAR_MESSAGE } from "./types";

export const snackBarInitialState = {
  snackBarMessage: {
    show: false,
    autoHideDuration: 5000,
    message: "",
    severity: "success",
  },
};

export const snackBarReducer = (state = snackBarInitialState, action: any) => {
  switch (action.type) {
    case SNACKBAR_MESSAGE:
      return {
        ...state,
        snackBarMessage: action.snackBarAlertProps,
      };
    default:
      return state;
  }
};
